import { useEffect, useMemo, useState } from "react";
import { Table, Tag, Typography, message } from "antd";
import { postReq } from "../api.js";
import moment from "moment";

const { Title } = Typography;

const MyCorrection = () => {
  const [corrections, setCorrections] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 10,
    page: 1,
  });

  const fetchCorrections = async () => {
    setLoading(true);
    try {
      const res = await postReq("/user/getCorrections", {
        page: paginationModel.page,
        limit: paginationModel.pageSize,
        search: "",
      });
      if (res.status === 200) {
        setCorrections(res.data.data);
        setTotal(res.data.total);
      } else {
        message.error(res.message || "Error while fetching data");
      }
    } catch (error) {
      message.error(error.message || "Error while fetching data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCorrections();
  }, [paginationModel]);

  const statusColor = (status) => {
    switch (status) {
      case "APPROVED":
        return "success";
      case "REJECTED":
        return "error";
      case "PENDING":
        return "warning";
      default:
        return "default";
    }
  };

  const columns = useMemo(
    () => [
      {
        title: "Date",
        dataIndex: "date",
        key: "date",
        width: 120,
        render: (val) => moment(val).format("DD/MM/YYYY"),
      },
      {
        title: "Attendance Time",
        dataIndex: "attendanceId",
        key: "attendanceId",
        width: 200,
        render: (attendanceId) =>
          `${moment(attendanceId?.loginTime).format("HH:mm A")} - ${moment(attendanceId?.logoutTime).format("HH:mm A")}`,
      },
      {
        title: "Requested Time",
        key: "requestedTime",
        width: 200,
        render: (_, row) =>
          `${moment(row.requestedLogin).format("HH:mm A")} - ${moment(row.requestedLogout).format("HH:mm A")}`,
      },
      {
        title: "Status",
        dataIndex: "status",
        key: "status",
        width: 130,
        render: (status) => (
          <Tag color={statusColor(status)} style={{ fontWeight: 500 }}>
            {status}
          </Tag>
        ),
      },
      {
        title: "Updated On",
        dataIndex: "updatedAt",
        key: "updatedAt",
        width: 170,
        render: (val) => moment(val).format("DD/MM/YYYY HH:mm"),
      },
      {
        title: "Approved By",
        dataIndex: "managerId",
        key: "managerId",
        render: (managerId) => (managerId ? `${managerId.name}` : "-"),
      },
    ],
    [],
  );

  return (
    <div style={{ padding: 32 }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: 24,
        }}
      >
        <Title level={4} style={{ margin: 0 }}>
          My Corrections
        </Title>
      </div>

      <Table
        loading={loading}
        dataSource={corrections}
        columns={columns}
        rowKey={(row) => row._id}
        scroll={{ x: "max-content" }}
        pagination={{
          current: paginationModel.page,
          pageSize: paginationModel.pageSize,
          total,
          showSizeChanger: true,
          pageSizeOptions: ["5", "10", "20"],
          showTotal: (tot) => `Total ${tot} records`,
          onChange: (page, pageSize) => setPaginationModel({ page, pageSize }),
        }}
      />
    </div>
  );
};

export default MyCorrection;
